var exports = {
  "OA": "xdde3148b--463041--fields",
  "ZZ": "xdde3148b--463041--field",
  "KN": "xdde3148b--463041--percent",
};

module.exports = exports;
